import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  min: z.number().default(0),
  max: z.number().default(100),
  step: z.number().positive().default(1),
  minLabel: z.string().max(60).optional(),
  maxLabel: z.string().max(60).optional(),
});

export const sliderField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "slider",
  label: "Slider",
  category: "rating",
  icon: "SlidersHorizontal",
  configSchema,
  valueSchema: (config, isRequired) =>
    optionalUnlessRequired(z.number().min(config.min).max(config.max), isRequired),
  defaultConfig: { min: 0, max: 100, step: 1 },
  supportsProfileBinding: false,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
